@if(loader){
<app-loader></app-loader>
}
<div class="flex justify-content-between align-items-center mt-3">

    <div>
        <p-button label="Save" (onClick)="save(CustProductForm.value)" icon="pi pi-save" size="small"></p-button>
        <p-button (onClick)="ref.close()"  label="Cancel" class="p-button-outlined ml-2 " icon="pi pi-times" severity="danger" size="small" ></p-button>

    </div>

</div>

<form [formGroup]="CustProductForm">
    <div class="grid mt-3">

        <div class="col">

            <div class="field text-left ">
                <label>Customer Product Code</label>
                <input formControlName="CustomerProductCode" [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.CustomerProductCode.errors }" pInputText class="w-full" />
            </div>

            <div class="field text-left">
                <label>Product Code</label>
                <span class="p-fluid">
                    <div style="display: flex;">
                        <p-autoComplete styleClass="w-full" field="productCode" formControlName="ProductCode"
                            (onSelect)="setProduct($event)" appendTo="body" [suggestions]="filterProductList"
                            (completeMethod)="autosearchProduct($event)" [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ProductCode.errors }">
                            <ng-template let-item pTemplate="item" class="text-left">
                                <span>{{item.productCode}} - {{item.productName}}</span>
                            </ng-template>
                        </p-autoComplete>
                        <button type="button" pButton pRipple (click)="showProductList()" icon="pi pi-search"
                            styleClass="p-button-warn" style="margin-left: 10px;"></button>
                    </div>
                </span>
            </div>


        </div>

        <div class="col"></div>
        <div class="col">
            <div class="field text-left flex justify-content-center">

                @if (previewImage) {
                <div style="border: 2px solid; border-radius: 10px; position: relative; object-fit: fill;">
                    <p-image [src]="previewImage" alt="Image" width="150px" height="140" [preview]="true"></p-image>
                </div>
                } @else {
                <label style="cursor: pointer;">
                    <img src="./assets/upload-logo.jpg" width="100px" alt="Image"
                        style="border: 2px solid; border-radius: 10px; position: static;">
                </label>
                }

            </div>
        </div>

    </div>

    <p-tabView>
        <p-tabPanel header="Product Information">

            <div class="grid mt-3">

                <div class="col">
                    <div class="field text-left ">
                        <label>Description</label>
                        <input formControlName="Description" pInputText readonly class="w-full" />
                    </div>
                    <div class="field text-left ">
                        <label>Category</label>
                        <input formControlName="Category" pInputText readonly class="w-full" />
                    </div>

                </div>

                <div class="col">

                    <div class="field text-left ">
                        <label>UOM</label>
                        <input formControlName="UOM" pInputText readonly class="w-full" />
                    </div>
                    <div class="field text-left ">
                        <label>Type</label>
                        <input formControlName="Type" pInputText readonly class="w-full" />
                    </div>

                </div>
                <div class="col"></div>

            </div>

        </p-tabPanel>
    </p-tabView>
</form>